import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import axios from "axios";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(SimpleVueValidation);
Vue.use(VueSweetalert2);

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

const Validator = SimpleVueValidation.Validator;

if (document.getElementById('login-app')) {
    const login = new Vue({
        el: "#login-app",
        data: {
            email: "",
            password: ""
        },
        validators: {
            email: function (value) {
                return Validator.value(value).required().email();
            },
            password: function (value) {
                return Validator.value(value).required();
            }
        },
        methods: {
            submit(url) {
                this.$validate().then(success => {
                    if (success) {
                        axios.post(url, {'email': this.email, 'password': this.password}).then(response => {
                            location.reload();
                        }).catch(error => {
                            const response = error.response;
                            if (response.status === 403) {
                                this.$swal({
                                    icon: 'warning',
                                    text: response.data.status
                                });
                            }
                        });
                    }
                });
            }
        }
    });
}

if (document.getElementById('forget-app')) {
    const forget = new Vue({
        el: "#forget-app",
        data: {
            email: "",
            onload: false
        },
        validators: {
            email: function (value) {
                return Validator.value(value).required().email();
            }
        },
        methods: {
            submit(url) {
                this.$validate().then(success => {
                    if (success) {
                        this.onload = true;
                        axios.post(url, {'email': this.email}).then(response => {
                            passwordClose();
                            this.email = "";
                            this.onload = false;

                            this.$swal({
                                icon: 'success',
                                text: response.data.status
                            });
                        }).catch(error => {
                            passwordClose();
                            this.email = "";
                            this.onload = false;

                            const response = error.response;

                            if (response.status === 422) {
                                let error = "";
                                Object.keys(response.data.errors).forEach(key => {
                                    error = response.data.errors[key].join('<br />');
                                });
                                this.$swal({
                                    icon: 'error',
                                    html: error
                                });
                            }

                            if (response.status === 403) {
                                this.$swal({
                                    icon: 'warning',
                                    text: response.data.status
                                });
                            }
                        });
                    }
                });
            }
        }
    });
}
